import script from "./ModalDeleteContentIntelligence.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ModalDeleteContentIntelligence.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDeleteContentIntelligence.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ModalDeleteContentIntelligence.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__